<template>
<div>
  <section class="content-header">
    <h1>
      学校订单历史明细
      <small>订单综合排行榜</small>
    </h1>
    <ol class="breadcrumb">
      <li><a href="#/"><i class="fa fa-dashboard"></i> Home</a></li>
      <li><a href="#/loudSpeakLearn/learnTime">订单综合排行榜</a></li>
      <li class="active">学校订单历史明细</li>
    </ol>
  </section>

  <section class="content">
    <el-card class="box-card" body-style="padding-bottom:0px">
      <el-form :inline="true" :model="filters">
				<el-form-item>
          <el-select v-model="filters.customers" multiple filterable clearable placeholder="客户名称" style="width: 360px">
            <el-option
              v-for="item in customers"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
				</el-form-item>
        <el-form-item v-show="$auth.check('ROLE_QOOCO')">
          <el-select v-model="filters.orgType" filterable clearable placeholder="机构类型">
            <el-option
              v-for="item in orgTypes"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="query">查询</el-button>
				</el-form-item>
			</el-form>
    </el-card>

    <el-card class="box-card">
      <div slot="header">
        <span class="header-text">用户详细数据</span>
        <el-button id="exportBtn" type="primary" icon="el-icon-download" @click="exportUserDetails">导出</el-button>
      </div>
      <div class="content">
        <el-table  @sort-change="sortChange" border :data="userDetails"  :default-sort = "{prop: 'org_name', order: 'ascending'}" >
          <el-table-column
            prop="org_name"
            label="客户名称"
            sortable="custom"
            width="180">
          </el-table-column>
          <el-table-column
            prop="total_orders"
            label="总订单数"
            sortable="custom"
            width="120">
          </el-table-column>
          <el-table-column
            prop="total_card_orders"
            label="总卡密订单数"
            sortable="custom"
            width="100">
          </el-table-column>
          <el-table-column
            prop="total_mys_orders"
            label="总MIS订单数"
            sortable="custom"
            width="100">
          </el-table-column>
          <el-table-column
            prop="tt_ordered_users"
            label="总订单用户数"
            sortable="custom"
            width="100">
          </el-table-column>
          <el-table-column
            prop="total_register_users"
            label="总注册用户数"
            sortable="custom"
            width="100">
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
  </section>
</div>
</template>

<script>
import $ from 'jquery'
import IEcharts from 'vue-echarts-v3/src/full'
import {mapGetters} from 'vuex'
import {loadUserDetails} from 'api/loud-speak-operate'
import {pagination, sortChange} from 'common/js/common-utils'
import {baseUrl} from 'api/base'

export default {
  computed: {
    ...mapGetters([
      'customers',
      'pickerOptions',
      'orgTypes'
    ])
  },
  data () {
    return {
      // condition
      filters: {
        customers: [],
        orgType: 'school'
      },
      // pagination
      currentPage: 1,
      total: 0,
      pageSize: 10,
      listAll: [],
      // business
      userDetails: [],
      loading: true
    }
  },
  components: {
    IEcharts
  },
  mounted () {
    this.query()
  },
  methods: {
    sortChange (obj) {
      sortChange(obj, this.listAll)
      this.handleCurrentChange(1)
    },
    pagination (page, pageSize, all) {
      this.userDetails = pagination(page, pageSize, all)
      this.total = all.length
    },
    exportUserDetails () {
      let form = $('<form>')
      form.attr('style', 'display:none')
      form.attr('target', '')
      form.attr('method', 'post')
      form.attr('action', baseUrl + 'exports/exportUserDetails')
      let input1 = $('<input>')
      let input2 = $('<input>')
      input1.attr('type', 'hidden')
      input1.attr('name', 'conditionStr')
      input1.attr('value', JSON.stringify(this.filters))
      input2.attr('type', 'hidden')
      input2.attr('name', 'token')
      input2.attr('value', localStorage.getItem('default_auth_token'))
      $('body').append(form)
      form.append(input1)
      form.append(input2)
      form.submit()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.pagination(1, val, this.listAll)
    },
    handleCurrentChange (val) {
      this.page = val
      this.pagination(val, this.pageSize, this.listAll)
    },
    query () {
      this._loadUserDetails(this.pageSize)
    },
    _loadUserDetails (pageSize) {
      loadUserDetails(this.filters)
      .then((res) => {
        this.listAll = res.data
        this.handleSizeChange(pageSize)
      }, (msg) => {
        this.$message.error(msg)
        this.listAll = []
        this.handleSizeChange(pageSize)
      })
    }
  }
}
</script>


<style lang="stylus" scoped>
  @import '~common/stylus/base'
  #exportBtn
    margin-left: 30px
</style>



// WEBPACK FOOTER //
// src/components/loud-speak-operate/user.vue